import * as Factory from 'factory.ts'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  type QuickBooksSyncSettingsConstructor,
  QuickBooksSyncSettings,
} from './QuickBooksSyncSettings'
import { SyncDateWindowConstructorFactory } from '../SyncDateWindow'

export const QuickBooksSyncSettingsConstructorFactory =
  Factory.Sync.makeFactory<QuickBooksSyncSettingsConstructor>({
    purchaseOrder: Factory.each(() => SyncDateWindowConstructorFactory.build()),
    bill: Factory.each(() => SyncDateWindowConstructorFactory.build()),
  })

export const QuickBooksSyncSettingsFactory = EntityFactory(
  QuickBooksSyncSettings,
  QuickBooksSyncSettingsConstructorFactory
)
